import React, { ReactNode } from 'react';
import styles from './card.module.scss';
import '../../theme/global.scss';
import CButton from '../button/button';
import { IoCloudDownload } from 'react-icons/io5';

interface ICard {
  date?: ReactNode;
  details?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  className?: any;
  downloadLink?: any;
}

const CCard = (props: ICard) => {
  return (
    <div className={styles.card}>
      {props.date && <p className='body-dark faded'>{props.date}</p>}
      <div className={styles.text}>
        <p className='body-dark bold'>{props.title}</p>
        {props.description && <p className='body-dark'>{props.description}</p>}
      </div>
      {props.details && <div className={styles.details}>{props.details}</div>}
      {props.downloadLink && (
        <CButton
          type='button'
          label={<IoCloudDownload />}
          onClick={props.downloadLink}
          className={styles.download}
        />
      )}
    </div>
  );
};

export default CCard;
